import React, { useContext, useState } from 'react';
import { ContentMisPacientes } from '../../components/MisPacientes/ContentMisPacientes';
import { MiFooter } from "../../components/footer/MiFooter";
import Header from "../../components/headers/Header";
import { UsuarioContext } from '../../contexts/UsuarioContext';
import './MisPacientes.css';


export const MisPacientes = () => {

  /* A hook that is used to change the state of the menu. */
  const [MenuLateralAux, setMenuLateralAux] = useState();

  const chageMenuLateralAux = () => {
    setMenuLateralAux(!MenuLateralAux)
  }
  return (
    <div className="MisPacientes">
      <div className="headerMisPacientes">
        <Header 
          chageMenuLateralAux={chageMenuLateralAux}
        />
      </div>
      <div className="bodyMisPacientes">
        <ContentMisPacientes 
          MenuLateralAux={MenuLateralAux}
          chageMenuLateralAux={chageMenuLateralAux}
        />
      </div>
      <div className="footerMisPacientes">
        <MiFooter />
      </div>
    </div>
  )
}